<template>
    <vx-dropdown-item>
        <font-awesome-icon widthAuto v-if="props.active" :icon="faCheck" class="w-4 -ml-2"></font-awesome-icon>
        <div v-else class="w-4 -ml-2"></div>
        <span class="w-20 text-left">
            <slot></slot>
        </span>
        <font-awesome-icon widthAuto v-if="props.icon" :icon="props.icon"></font-awesome-icon>
        <div v-else class="w-3"></div>
    </vx-dropdown-item>
</template>

<script setup>
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxDropdownItem } from '@voxie/frontend-components';

const props = defineProps({
    active: Boolean,
    icon: {
        type: Object,
        required: false,
    },
});
</script>
